export const PRODUCT_TOUR_MOBILE_BREAKPOINT = 768;
export const PRODUCT_TOUR_DEFAULT_WAIT_TIMEOUT_MS = 3000;
export const PRODUCT_TOUR_POLL_INTERVAL_MS = 100;
export const PRODUCT_TOUR_OVERLAY_OPACITY = 0.4;
export const PRODUCT_TOUR_QUERY_PARAM = 'productTour';
export const PRODUCT_TOUR_CLOSE_MODAL_ACTION = 'tour.close-modal';
